export function setBrands(state, payload) {
  state.brands = payload;
  state.error = false;
  state.errorMessage = "";
  state.success = false;
  state.successMessage = "";
}

export function setError(state, payload) {
  state.banners = null;
  state.banner = null;
  state.error = true;
  state.errorMessage = payload;
  state.success = false;
  state.successMessage = "";
}

export function setSuccess(state, payload) {
  state.banners = null;
  state.banner = null;
  state.error = false;
  state.errorMessage = "";
  state.success = true;
  state.successMessage = payload;
}
